import pxToRem from "./pxToRem";

const BP_SM = 800; // tablet start
const BP_MD = 1075; // desktop start

/** Apply 1.0× ≥md, 0.9× between sm..md, 0.8× ≤sm */
const fontSizeResponsive = (desktopPx: number) => ({
  fontSize: pxToRem(desktopPx), // ≥ MD
  [`@media (max-width:${BP_MD - 1}px) and (min-width:${BP_SM}px)`]: {
    fontSize: pxToRem(desktopPx * 0.9), // tablet
  },
  [`@media (max-width:${BP_SM - 1}px)`]: {
    fontSize: pxToRem(desktopPx * 0.8), // mobile
  },
});

export default fontSizeResponsive;